import firebase from 'firebase/app';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyAcEQ7haC7bXEkX2F4AWtqkHLe49Af4J7k",
    authDomain: "voter-b835f.firebaseapp.com",
    databaseURL: "https://voter-b835f.firebaseio.com",
    projectId: "voter-b835f",
    storageBucket: "voter-b835f.appspot.com",
    messagingSenderId: "781145166324",
    appId: "1:781145166324:web:8013a318cc5a7fa4"
};

firebase.initializeApp(firebaseConfig);

export default {
    database: firebase.database()
}